const AMSTERDAM_TZ = 'Europe/Amsterdam';

/**
 * The backend's `periodEnd` is the last millisecond of the usage month
 * (31 Oct 23:59:59.999 Amsterdam). The meter resets one millisecond later, at
 * the start of the next month, so that is the date to show. Formatted in
 * Europe/Amsterdam, like the backend's period, whatever the browser's zone.
 */
export const usageResetDate = (periodEnd?: string | Date | null, locale?: string): string | null => {
  if (!periodEnd) return null;
  const end = new Date(periodEnd);
  if (Number.isNaN(end.getTime())) return null;
  return new Date(end.getTime() + 1).toLocaleDateString(locale, { timeZone: AMSTERDAM_TZ });
};
